import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import BooksService from "../../Services/Books";
import ArticlesService from "../../Services/Articles";
import GeetGovindServices from '../../Services/GeetGovind';
import KalyansServices from '../../Services/Kalyan';
import KalpataruServices from '../../Services/Kalpataru';
import VivekService from '../../Services/Vivekvani';
import AudiosService from '../../Services/Audios';
import VideoService from '../../Services/VideoPlayer';
import DivineQuotesService from '../../Services/DivineQuotes';
import i18n from '../../i18n';
import LatestSection from '../../Components/LatestSection';
import { useDownloadApp } from '../../Contexts/DownloadAppContext';
import { Product } from './MobileMagazines';

const Latest = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setShowDownloadPopup } = useDownloadApp();
  const [latestBooks, setLatestBooks] = useState<any[]>([]);
  const [totalLatestBooks, setTotalLatestBooks] = useState(0);
  const [latestArticles, setLatestArticles] = useState<any[]>([]);
  const [totalLatestArticles, setTotalLatestArticles] = useState(0);
  const [latestGeetgovindHindi, setLatestGeetgovindHindi] = useState<any[]>([]);
  const [totalLatestGeetgovindHindi, setTotalLatestGeetgovindHindi] = useState(0);
  const [latestGeetgovindEnglish, setLatestGeetgovindEnglish] = useState<any[]>([]);
  const [totalLatestGeetgovindEnglish, setTotalLatestGeetgovindEnglish] = useState(0);
  const [geetGovindLanguageIds, setGeetGovindLanguageIds] = useState<{ hindi?: string; english?: string }>({});
  const [latestKalyan, setLatestKalyan] = useState<any[]>([]);
  const [totalLatestKalyan, setTotalLatestKalyan] = useState(0);
  const [latestKalpataru, setLatestKalpataru] = useState<any[]>([]);
  const [totalLatestKalpataru, setTotalLatestKalpataru] = useState(0);
  const [latestVivekVani, setLatestVivekVani] = useState<any[]>([]);
  const [totalLatestVivekVani, setTotalLatestVivekVani] = useState(0);
  const [latestAudios, setLatestAudios] = useState<any[]>([]);
  const [totalLatestAudios, setTotalLatestAudios] = useState(0);
  const [latestPravachans, setLatestPravachans] = useState<any[]>([]);
  const [totalLatestPravachans, setTotalLatestPravachans] = useState(0);
  const [latestDailySatsang, setLatestDailySatsang] = useState<any[]>([]);
  const [totalLatestDailySatsang, setTotalLatestDailySatsang] = useState(0);
  const [latestVideos, setLatestVideos] = useState<any[]>([]);
  const [totalLatestVideos, setTotalLatestVideos] = useState(0);
  const [latestDivineQuotes, setLatestDivineQuotes] = useState<any[]>([]);
  const [totalLatestDivineQuotes, setTotalLatestDivineQuotes] = useState(0);
  const [loadingLatest, setLoadingLatest] = useState<boolean>(true);
  const [loadingLatestBooks, setLoadingLatestBooks] = useState<boolean>(true);

  const booksLimit = 10;
  const latestSortOption = "2";
  const articlesLimit = 10;
  const geetGovindFetchLimit = 8;
  const latestSectionLimit = 8;

  useEffect(() => {
    if (latestBooks.length > 0) { setLoadingLatestBooks(false); return; }
    BooksService.getBooks(
      0,
      booksLimit,
      false,
      "",
      "",
      "",
      latestSortOption,
      "",
      false
    ).then((res: any) => {
      if (res.status) {
        setLatestBooks(res.result.items?.map((item: any) => ({
          title: item.name,
          img: item.bookThumbPath,
          id: item.id,
          slug: item.slug,
        })) || []);
        setTotalLatestBooks(res.result.totalRecords || 0);
      }
    }).catch((error: any) => {
      console.error("Error fetching latest books:", error);
    }).finally(() => {
      setLoadingLatestBooks(false);
    });

  }, [i18n.language]);

  useEffect(() => {
    if (latestArticles.length > 0) return;
    ArticlesService.getArticles(
      0,
      articlesLimit,
      false,
      "",
      "",

      "",

      "1",
      "",
      false
    ).then((res: any) => {
      if (res.status) {
        setLatestArticles(res.result.items?.map((item: any) => ({
          title: item.name,
          img: item.articleThumbPath,
          id: item.id
        })) || []);
        setTotalLatestArticles(res.result.totalRecords || 0);
      }
    }).catch((error: any) => {
      console.error("Error fetching latest articles:", error);
    });
  }, [])

  useEffect(() => {
    if (geetGovindLanguageIds.hindi && geetGovindLanguageIds.english) return;
    GeetGovindServices.getGeetFilters("monthlymagazine")
      .then((res: any) => {
        if (res?.status && Array.isArray(res.result?.languages)) {
          const languages = res.result.languages;
          const normalize = (value: any) =>
            value?.toString().toLowerCase().trim() || "";

          const isHindi = (langName: string) =>
            ["hindi", "hin", "हिंदी", "हिन्दी", "हिं", "हिन्द"].some((term) =>
              normalize(langName).includes(term)
            );
          const isEnglish = (langName: string) =>
            ["english", "eng"].some((term) =>
              normalize(langName).includes(term)
            );

          const hindiLang = languages.find((lang: any) =>
            isHindi(lang.name) || isHindi(lang.label) || lang.code === "hi"
          );
          const englishLang = languages.find((lang: any) =>
            isEnglish(lang.name) || isEnglish(lang.label) || lang.code === "en"
          );

          setGeetGovindLanguageIds({
            hindi: hindiLang?.id || languages[0]?.id,
            english: englishLang?.id || languages[1]?.id,
          });
        }
      })
      .catch((error: any) => {
        console.error("Error fetching GeetGovind languages:", error);
      });
  }, [i18n.language]);

  useEffect(() => {
    if (latestGeetgovindHindi.length > 0 && latestGeetgovindEnglish.length > 0) return;
    const fetchLatestGeetGovind = async (
      languageId: string | undefined,
      setItems: React.Dispatch<React.SetStateAction<any[]>>,
      setTotal: React.Dispatch<React.SetStateAction<number>>
    ) => {
      if (!languageId) return;

      try {
        const res: any = await GeetGovindServices.getMonthlyMagazine(
          "",
          0,
          geetGovindFetchLimit,
          "",
          false,
          "2",
          "",
          languageId,
          false,
          "",
          ""
        );

        if (res?.status) {
          setItems(
            res.result.items?.map((item: any) => ({
              title: item.name,
              img: item.monthlyMagazineThumbPath,
              id: item.id,
              slug: item.slug,
              languageId: item.monthlyMagazineLanguageId,
            })) || []
          );
          setTotal(res.result.totalRecords || 0);
        }
      } catch (error: any) {
        console.error("Error fetching latest GeetGovind for language:", languageId, error);
      }
    };

    fetchLatestGeetGovind(
      geetGovindLanguageIds.hindi,
      setLatestGeetgovindHindi,
      setTotalLatestGeetgovindHindi
    );
    fetchLatestGeetGovind(
      geetGovindLanguageIds.english,
      setLatestGeetgovindEnglish,
      setTotalLatestGeetgovindEnglish
    );
  }, [geetGovindLanguageIds]);

  useEffect(() => {
    if (latestKalyan.length > 0) return;
    const fetchLatestSections = async () => {
      try {
        const [
          kalyanRes,
          kalpataruRes,
          vivekRes,
          audiosRes,
          pravachansRes,
          dailySatsangRes,
          videosRes,
          divineQuotesRes,
        ] = await Promise.all([
          KalyansServices.getKalyans(
            0,
            latestSectionLimit,
            false,
            "",
            "",
            "",
            "2",
            "",
            false
          ),
          KalpataruServices.getKalyansKalpataru(
            0,
            latestSectionLimit,
            false,
            "",
            "",
            "",
            "2",
            "",
            false
          ),
          VivekService.getVanis(
            0,
            latestSectionLimit,
            "",
            false,
            "2",
            "",
            "",
            "",
            false
          ),
          AudiosService.getAudios(
            0,
            latestSectionLimit,
            false,
            "",
            "",
            "",
            "2",
            "",
            false,
            "audios",
            0,
            "",
            "",
            "",
            "",
            false

          ),
          AudiosService.getAudios(
            0,
            latestSectionLimit,
            false,
            "",
            "",
            "",
            "2",
            "",
            false,
            "pravachans",
            0,
            "",
            "",
            "",
            "",
            false

          ),
          AudiosService.getAudioPodcast(
            0,
            latestSectionLimit,
            "2",
            "0",
            "0"
          ),
          VideoService.getAllVideos("", "", "2", latestSectionLimit),
          DivineQuotesService.getDivineQuotes("", 0, latestSectionLimit),
        ]);

        if (kalyanRes?.status) {
          setLatestKalyan(
            kalyanRes.result.items?.map((item: any) => ({
              title: item.name,
              img: item.kalyanThumbPath,
              id: item.id,
              slug: item.slug,
              languageId: item.kalyanLanguage,
            })) || []
          );
          setTotalLatestKalyan(kalyanRes.result.totalRecords || 0);
        }

        if (kalpataruRes?.status) {
          setLatestKalpataru(
            kalpataruRes.result.items?.map((item: any) => ({
              title: item.name,
              img: item.kalyanKalpataruThumbPath,
              id: item.id,
              slug: item.slug,
              languageId: item.kalyanKalpataruLanguage,
            })) || []
          );
          setTotalLatestKalpataru(kalpataruRes.result.totalRecords || 0);
        }

        if (vivekRes?.status) {
          setLatestVivekVani(
            vivekRes.result.items?.map((item: any) => ({
              title: item.name,
              img: item.vivekVaniThumbPath,
              id: item.id,
              slug: item.slug,
              languageId: item.vivekVaniLanguage,
            })) || []
          );
          setTotalLatestVivekVani(vivekRes.result.totalRecords || 0);
        }

        if (audiosRes?.status) {
          setLatestAudios(
            audiosRes.result.items?.map((item: any) => ({
              title: item.name,
              img: item.bookThumbPath || item.vivekVaniThumbPath || item.kalyanThumbPath || item.kalyanKalpataruThumbPath || item.monthlyMagazineThumbPath,
              id: item.id,
            })) || []
          );
          setTotalLatestAudios(audiosRes.result.totalRecords || 0);
        }

        if (pravachansRes?.status) {
          setLatestPravachans(
            pravachansRes.result.items?.map((item: any) => ({
              title: item.name,
              img: item.bookThumbPath || item.vivekVaniThumbPath || item.kalyanThumbPath || item.kalyanKalpataruThumbPath || item.monthlyMagazineThumbPath,
              id: item.id,
              slug: item.slug,
            })) || []
          );
          setTotalLatestPravachans(pravachansRes.result.totalRecords || 0);
        }

        if (dailySatsangRes?.status) {
          setLatestDailySatsang(
            dailySatsangRes.result.items?.map((item: any) => ({
              title: item.name,
              img: item.bookThumbPath || item.vivekVaniThumbPath || item.kalyanThumbPath || item.kalyanKalpataruThumbPath || item.monthlyMagazineThumbPath,
              id: item.id,
              slug: item.slug,
            })) || []
          );
          setTotalLatestDailySatsang(dailySatsangRes.result.totalRecords || 0);
        }

        if (videosRes?.status) {
          setLatestVideos(
            videosRes.result.items?.map((item: any) => ({
              title: item.name,
              img: item.videoHash ? `https://img.youtube.com/vi/${item.videoHash}/hqdefault.jpg` : item.videoPath || item.videoUrl || item.bookThumbPath,
              id: item.id,
              slug: item.slug,
            })) || []
          );
          setTotalLatestVideos(videosRes.result.totalRecords || 0);
        }

        if (divineQuotesRes?.status) {
          setLatestDivineQuotes(
            divineQuotesRes.result.items?.map((item: any, index: number) => ({
              title: item.name || `Divine Quote ${index + 1}`,
              img: item.quotesThumbPath,
              id: String(index),
            })) || []
          );
          setTotalLatestDivineQuotes(divineQuotesRes.result.totalRecords || 0);
        }
      } catch (error: any) {
        console.error('Error fetching latest sections:', error);
      } finally {
        setLoadingLatest(false);
      }
    };

    fetchLatestSections();
  }, [i18n.language]);

  return (
    <>
      {/* <div style={{ backgroundColor: "#F2F0EF", height: "100vh", overflow: "hidden", display: "flex", flexDirection: "column" }}> */}
      {/* Header */}

      {/* Latest Books Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('E_books_tr')}
          items={latestBooks}
          totalRecords={totalLatestBooks}
          itemType={t('itemtype_books_tr')}
          onItemClick={(id?: string, item?: any) => navigate(`/books/${item?.slug}`)}
          onViewAllClick={() => {
            navigate('/books', {
              state: {
                sortOption: latestSortOption,
                pinnedLatestBook: latestBooks[0],
              },
            });
          }}
          loading={loadingLatestBooks}
        />
      </div>
      {/* Latest Geetgovind Hindi Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('itemtype_geetgovind_hindi_tr')}
          items={latestGeetgovindHindi}
          totalRecords={totalLatestGeetgovindHindi}
          itemType={t('itemtype_geetgovind_hindi_tr')}
          onItemClick={(id?: string, item?: any) =>
            navigate('/magazines/geetgovind', {
              state: {
                geetGovindId: id || item?.id,
                magzineId: id || item?.id,
                geetGovindLang: 'hindi',
                magazineLanguage: geetGovindLanguageIds.hindi,
                bookName: item?.title || item?.name,
                slug: item?.slug,
                productType: Product.MonthlyMagazine,
              },
            })
          }
          onViewAllClick={() =>
            navigate('/magazines/geetgovind', {
              state: {
                type: 'geetGovind',
                showGeetGovindList: true,
                magazineLang: geetGovindLanguageIds.hindi,
                geetGovindLang: 'hindi',
                sortOption: latestSortOption,
              },
            })
          }
          loading={loadingLatest}
        />
      </div>
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('itemtype_geetgovind_english_tr')}
          items={latestGeetgovindEnglish}
          totalRecords={totalLatestGeetgovindEnglish}
          itemType={t('itemtype_geetgovind_english_tr')}
          onItemClick={(id?: string, item?: any) =>
            navigate('/magazines/geetgovind', {
              state: {
                geetGovindId: id || item?.id,
                magzineId: id || item?.id,
                geetGovindLang: 'english',
                magazineLanguage: geetGovindLanguageIds.english,
                bookName: item?.title || item?.name,
                slug: item?.slug,
                productType: Product.MonthlyMagazine,
              },
            })
          }
          onViewAllClick={() =>
            navigate('/magazines/geetgovind', {
              state: {
                type: 'geetGovind',
                showGeetGovindList: true,
                magazineLang: geetGovindLanguageIds.english,
                geetGovindLang: 'english',
                sortOption: latestSortOption,
              },
            })
          }
          loading={loadingLatest}
        />
      </div>
      {/* Latest Articles Section */}

      {/* Latest Kalyan Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('itemtype_kalyan_tr')}
          items={latestKalyan}
          totalRecords={totalLatestKalyan}
          itemType={t('itemtype_kalyan_tr')}
          onItemClick={(id?: string, item?: any) =>
            navigate(`/magazines/kalyan/${item?.slug || id}`, {
              state: {
                kalyansId: id || item?.id,
                magzineId: id || item?.id,
                bookName: item?.title || item?.name,
                slug: item?.slug,
              },
            })
          }
          onViewAllClick={() =>
            navigate('/magazines/kalyan', {
              state: { allKalyans: true, sortOption: latestSortOption },
            })
          }
          loading={loadingLatest}
        />
      </div>

      {/* Latest Kalyan Kalpataru Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('itemtype_kalpataru_tr')}
          items={latestKalpataru}
          totalRecords={totalLatestKalpataru}
          itemType={t('itemtype_kalpataru_tr')}
          onItemClick={(id?: string, item?: any) =>
            navigate(`/magazines/kalyanakalpataru/${item?.slug || id}`, {
              state: {
                kalpataruId: id || item?.id,
                kalyansId: id || item?.id,
                magzineId: id || item?.id,
                isKalpataruBook: true,
                bookName: item?.title || item?.name,
                slug: item?.slug,
              },
            })
          }
          onViewAllClick={() =>
            navigate('/magazines/kalyanakalpataru', {
              state: { allKalpataru: true, sortOption: latestSortOption },
            })
          }
          loading={loadingLatest}
        />
      </div>

      {/* Latest Vivek Vani Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('All_Vivek_Vani')}
          items={latestVivekVani}
          totalRecords={totalLatestVivekVani}
          itemType={t('All_Vivek_Vani')}
          onItemClick={(id?: string, item?: any) =>
            navigate(`/magazines/vivekvani/${item?.slug || id}`, {
              state: {
                vivekVaniId: id || item?.id,
                magzineId: id || item?.id,
                isVivekVaniBook: true,
                bookName: item?.title || item?.name,
                slug: item?.slug,
              },
            })
          }
          onViewAllClick={() =>
            navigate('/magazines/vivekvani', {
              state: { vivekVaniId: Product.VivekVani, sortOption: latestSortOption },
            })
          }
          loading={loadingLatest}
        />
      </div>

      {/* Latest Audio Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('Audio_tr')}
          items={latestAudios}
          showDailySatsangLogo={true}
          totalRecords={totalLatestAudios}
          itemType={t('itemtype_audios_tr')}
          onItemClick={(id?: string) => {
            navigate('/mobileAudioListPage', { state: { type: "audios", sortOption: latestSortOption, audioId: id } });
          }}
          onViewAllClick={() => navigate('/mobileAudioListPage', { state: { type: "audios", sortOption: latestSortOption } })}
          loading={loadingLatest}
        />
      </div>

      {/* Latest Pravachan Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('Pravachan_tr')}
          items={latestPravachans}
          showDailySatsangLogo={true}
          totalRecords={totalLatestPravachans}
          itemType={t('itemtype_pravachans_tr')}
          onItemClick={(id?: string) => {
            navigate('/mobileAudioListPage', { state: { type: "pravachans", sortOption: latestSortOption, audioId: id } });
          }}
          onViewAllClick={() => navigate('/mobileAudioListPage', { state: { type: "pravachans", sortOption: latestSortOption } })}
          loading={loadingLatest}
        />
      </div>

      {/* Latest Daily Satsang Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('daily_satsang_tr')}
          items={latestDailySatsang}
          totalRecords={totalLatestDailySatsang}
          showDailySatsangLogo={true}
          itemType={t('daily_satsang_tr')}
          onItemClick={(id?: string) => {
            navigate('/DailySatsang', { state: { type: "DailySatsang", sortOption: latestSortOption, audioId: id } });
          }}
          onViewAllClick={() => navigate('/DailySatsang', { state: { type: "DailySatsang", sortOption: latestSortOption } })}
          loading={loadingLatest}
        />
      </div>

      {/* Latest Video Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('Video_tr')}
          items={latestVideos}
          totalRecords={totalLatestVideos}
          hideImage={true}
          itemType={t('itemtype_videos_tr')}
          onItemClick={(id?: string) => {
            const logdetails: string[] = [];
            logdetails.push("action=mobile_latest_video_click");
            logdetails.push(`videoId=${id || "none"}`);
            setShowDownloadPopup(true);
            logdetails.push("download_popup=shown");
            console.log("Latest ->", logdetails.join(" | "));
          }}
          onViewAllClick={() => navigate('/videos')}
          loading={loadingLatest}
        />
      </div>

      {/* Latest Articles Section */}
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('Articles_tr')}
          items={latestArticles}
          showArticleLogo={true}
          totalRecords={totalLatestArticles}
          itemType={t('Articles_tr')}
          onItemClick={(id?: string) => navigate('/readArticles', { state: { articleId: id } })}
          onViewAllClick={() => navigate('/articles', { state: { allArticles: true } })}
          loading={loadingLatest}
        />
      </div>
      <div style={{ flexShrink: 0 }}>
        <LatestSection
          title={t('Amrit_Vachan_tr')}
          items={latestDivineQuotes}
          totalRecords={totalLatestDivineQuotes}
          itemType={t('Amrit_Vachan_tr')}
          onItemClick={() => navigate('/divineQuotes')}
          onViewAllClick={() => setShowDownloadPopup(true)}
          loading={loadingLatest}
        />
      </div>
      {/* Footer */}
      {/* <div
        style={{
          width: "100%",
          height: "40px",
          backgroundColor: "#f97316",
          position: "fixed",
          bottom: 0,
          left: 0,
          padding: 18,
          }}
      ></div> */}
      {/* </div> */}
    </>
  );
};

export default Latest;